<template>
    <div class="qwen_ai_header">
        <div class="header_left">
            <span>产出管理</span>
        </div>
        <div class="header_right">
            <div class="button_row">
                <span>帮助中心</span>
            </div>
            <div class="button_row share_button">
                <ShareAltOutlined />
                <span>邀请同时</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    ShareAltOutlined
} from '@ant-design/icons-vue';
import { ref } from 'vue';

const selectedKeys = ref(['new']);

</script>

<style lang="scss">
.qwen_ai_header {
    height: 68px;
    padding: 0 30px;
    background: #f9fafdeb;
    border-bottom: 1px solid #e8eaf0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header_left {
        font-size: 14px;
        font-weight: bold;
    }

    .header_right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
        font-size: 13px;

        .button_row {
            padding: 8px 13px;
            border-radius: 8px;
            color: #676d78;
            cursor: pointer;
        }

        .share_button {
            padding: 8px 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            background: #edf4ff;
            color: #3976f6;
            border: 1px solid #e1ebff;
            border-radius: 8px;
            cursor: pointer;
        }
    }
}
</style>